import { Stack, StackProps, useTheme } from '@mui/material'
import { PropsWithChildren } from 'react'

const ModuleHeader = ({
  children,
  ...props
}: PropsWithChildren & StackProps) => {
  const theme = useTheme()
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        p: 2,
        borderBottom: '1px solid',
        borderColor: theme.extraColors.border
      }}
      {...props}
    >
      {children}
    </Stack>
  )
}

export default ModuleHeader
